export enum SharpenPageType {
  HE_PDP = 'HE_PDP',
  MHP_PDP = 'MHP_PDP',
  CART = 'CART',
  TUNNEL_CART = 'TUNNEL_CART',
}

export const SHARPEN_PROGRAM_ID = 'MKTGPRG1265321183';

export const SHARPEN_LEARN_MORE_URL = 'https://www.mheducation.com/sharpen/faculty.html';

export const SHARPEN_WIDGET_TITLE = 'Recommended by McGraw Hill';

export const SHARPEN_TILE_TITLE = 'Sharpen Plus Study App';

export const SHARPEN_DESCRIPTION = `Get instant access to thousands of quizzes, flashcards, guided solutions, and your own AI study buddy—everything you need to ace your next exam.`;

export const SHARPEN_TUNNEL_DESCRIPTION = 'Instant access to an AI study buddy, thousands of quizzes, guided solutions, videos, and more — all in one place.';

export const SHARPEN_TUNNEL_DESCRIPTION_WITH_TERMS = `${SHARPEN_TUNNEL_DESCRIPTION} Terms apply.**`;

export const SHARPEN_NATIONAL_LAUNCH_URL = 'https://mhss-links.mheducation.com/G1f2/5a6y3d71';

export const SHARPEN_TUNNEL_LAUNCH_URL = `https://mhss-links.mheducation.com/G1f2/5a6y3d71`;

export const SHARPEN_COMPANION_LAUNCH_URL = `https://mhss-links.mheducation.com/G1f2/h02nf93h`;

export const GO_COMPANION_LAUNCH_URL = `https://mhss-links.mheducation.com/G1f2/k79kavh7`;

export const SHARPEN_ADVANTAGE_LAUNCH_URL = `https://mhss-links.mheducation.com/G1f2/s68sqkmq`;

export const ALEKS_SHARPEN_COMPANION_LAUNCH_URL = `https://mhss-links.mheducation.com/G1f2/4mhojums`;

export const SHARPEN_ANALYTICS_PRODUCT_TYPE = 'SHARPEN_PLUS';

export const SHARPEN_SEO_TITLE_INITIALS = 'sharpen-plus';

export type SharpenBoughtWithAnalyticsDataType = {
  title: string;
  isbn: string;
  isbn13: string;
  programSourceId: string;
};
